import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, watch, nextTick } from 'vue'
import { mathliveState } from '../stores/mathlive'
import hotkeys from 'hotkeys-js'


export default /*@__PURE__*/_defineComponent({
  __name: 'MathLiveComponent',
  setup(__props) {

const mathField = ref<any>(null)
const dialogVisible = ref(false)

const isShow = computed(() => mathliveState.isShow)

watch(isShow, () => {
  if (isShow.value) {
    dialogVisible.value = true
    settupHotKeys()
    nextTick(() => {
      onOpened()
    })
  } else {
    dialogVisible.value = false
    removeHotkeys()
  }
})

const onDialogChange = (value: boolean) => {
  if (!value && isShow.value) {
    onCancel()
  }
}

const onOpened = () => {
  mathField.value = (window as any).MathLive.makeMathField('mathlive-editor', {
    smartMode: true,
    virtualKeyboardMode: 'onfocus',
    onContentDidChange: (mf: any) => {
      const latex = mf.$text()
      mathliveState.setLatex(latex)
    }
  })

  mathField.value.$latex(mathliveState.latex)
  mathField.value.$focus()
}

const settupHotKeys = () => {
  hotkeys.filter = () => {
    return true
  }

  hotkeys('alt+enter', 'mathlive', () => {
    onOk()
  })

  hotkeys.setScope('mathlive')
}

const removeHotkeys = () => {
  hotkeys.deleteScope('mathlive')

  // Mathliveが終わったら、Editorに戻りますので、EditorのScopeにactiveしないといけません
  hotkeys.setScope('editor')
}

const onOk = () => {
  mathliveState.hide()
}

const onCancel = () => {
  if (mathliveState.isShow) {
    mathliveState.cancel()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
      onDialogChange
    ],
    width: "420",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-4" }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { id: "mathlive-editor" }, null, -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, { class: "justify-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                size: "small",
                variant: "outlined",
                color: "indigo",
                onClick: onOk
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("OK", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})